import { getBookmarkList, renderAll, setState } from '../core';
import {
  appendFile,
  cleanLocalBookmarks,
  getPageType,
  initOnboarding,
  isLoggedIn,
  isPageBookmarked,
  updateOrRetrieveBookmarkEvents,
  userHasReachedLimit,
} from '../helpers';
import { Actions } from '../resources';

// initialize state (and trigger first render)
export const initialize = async (brandName: BrandName) => {
  const pageType = await getPageType();
  // just don't load when it's not needed
  if (!pageType) return;

  appendFile('bookmarking-base.css');
  appendFile(`bookmarking-${brandName}.css`);

  const sessionLoggedIn = (await isLoggedIn()) || false;

  //count article views
  initOnboarding(pageType);

  const showOnboardingPopup = userHasReachedLimit();

  if (!sessionLoggedIn) {
    //remove local storage in case the user switches
    cleanLocalBookmarks();

    setState({
      article: 'not-logged-in',
      showOnboardingPopup,
      modalVisible: showOnboardingPopup,
      pageType,
      brandName,
    });

    // Reactively update the UI for consecutive updates
    document.addEventListener(Actions.UPDATE_STORE, () => {
      renderAll(false);
    });

    //force initial render
    renderAll(true);

    return;
  }

  const eventList = await updateOrRetrieveBookmarkEvents(pageType);

  let articleIsBookmarked;
  let article: StateType['article'] = 'unknown';
  if (pageType === 'article') {
    articleIsBookmarked = isPageBookmarked(eventList) || undefined;
    article = articleIsBookmarked ? 'bookmarked' : 'not-bookmarked';
  }

  let bookmarkList;
  let listHasMoreTeasers = false;
  if (pageType === 'list') {
    const bookmarkListResponse = await getBookmarkList(0);
    bookmarkList = bookmarkListResponse.bookmarks;
    listHasMoreTeasers = bookmarkListResponse.hasMoreTeasers;
  }

  // this initial setState won't rerender yet, because we haven't registered the listener.
  setState({
    eventList,
    pageType,
    article,
    bookmarkList,
    listHasMoreTeasers,
    sessionLoggedIn,
    showOnboardingPopup,
    modalVisible: showOnboardingPopup,
    brandName,
  });

  //force initial render
  renderAll(true);

  // Reactively update the UI for consecutive updates
  document.addEventListener(Actions.UPDATE_STORE, () => {
    renderAll(false);
  });
};
